<template lang="pug">
  .table-responsive
    table#tbItemsResponsivas.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th.is-size-6
            input#sel_all.is-checkradio(type='checkbox' v-model="selectAll")
            label.is-size-6(for='sel_all') Todos
          th.is-size-6 
            | Categoría
          th.is-size-6 
            | Descripción (Serie | Marca | Modelo)
      tbody
        tr(v-for="(art, index) in articulos" :key="art.id")
          td
            .field
              input.is-checkradio(type='checkbox' v-model="itemsSelected" :value="art" :id="art.id" :disabled="isDisabled")
              label(:for="art.id") {{ index + 1 }}
          td(v-if="art.subcategoria")
            .tags.has-addons
              span.tag.is-black
                | {{ art.categoria}}
              span.tag.is-warning 
                | {{ art.subcategoria}}
          td(v-else) 
            span.tag.is-black {{ art.categoria}}
          td 
            .tags.has-addons
              span.tag.is-black
                | {{ art.serie }}
              span.tag.is-dark
                | {{ art.marca }}
              span.tag.is-light
                | {{ art.modelo}}
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
  export default {
    name: 'TbItems_Responsiva',
    props: {
      articulos: {
        type: Array,
        default: () => []
      },
      disabledItems: {
        type: Boolean,
        default: false
      },
      reset: {
        type: Boolean,
        default: false
      },
      itemsSel: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        hayDatos: false,
        itemsSelected: [],
        isDisabled: this.disabledItems,
        selectAll: false
      }
    },
    watch: {
      articulos() {
        this.checkDatos()  
      },
      
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = []
        }
      },
      itemsSel () {
        this.itemsSelected =  this.itemsSel
      },
      selectAll () {
        if (this.selectAll) {
          this.itemsSelected = this.articulos
        } else {
          this.itemsSelected = []
        }
      }
      
    },
    methods: {
      iniciarComponente () {
        console.log(this.itemsSel)
        this.checkDatos()
      },
      checkDatos () {
        if (this.articulos.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/TbItems_Responsiva.vue